module.exports = __webpack_public_path__ + "static/media/3DPPA14.5a296b62.jpg";